import React from "react";
import { DataTable, Pagination } from "pepsico-ds";
import { useSelector } from "react-redux";
import "../theme/PeacockDesign.css";
interface Data {
  [key: string]: any;
}
interface AppTableProps {
  data: Data[];
  columns: any[];
  tableLength: number;
  pageNumber: number;
  onPageChange: (index: number) => void;
}

const AppTable = ({
  data,
  columns,
  onPageChange,
  tableLength,
  pageNumber,
}: AppTableProps) => {
  const isSidebarCollapsed = useSelector(
    (state: any) => state.sidebar.isCollapsed
  );
  return (
    <>
        <div
          className={`appTable ${
            isSidebarCollapsed ? "collapsed" : "expanded"
          }`}
        >
          <DataTable
            columns={columns}
            data={data}
            isLoading={false}
            isDark={false}
            isExpandable={false}
            pageIndex={pageNumber}
            pageSize={10}
            manualPagination={true}
            onPageIndexChange={onPageChange}
            totalRowsCount={tableLength}
            selection="single"
            size="large"
            showFilterToolbar={false}
            showColumnFilters={false}
            enableSorting={false}
          />
        </div>
      <Pagination
        currentPage={pageNumber}
        onUpdate={onPageChange}
        pageCount={Math.ceil(tableLength / 10)}
        size="medium"
        variant="number"
        className="appPagination"
      />
    </>
  );
};
export default AppTable;
